import { useEffect, useState } from 'react';

import { ANIMATION_START_DELAY_MS, ANIMATION_WORD_DELAY_MS } from '../utils/feedbackStorageUtils';

type UseAiSummaryWordAnimationResult = Readonly<{
	animationComplete: boolean;
	visibleWords: number;
}>;

export function useAiSummaryWordAnimation(shouldAnimate: boolean, wordCount: number): UseAiSummaryWordAnimationResult {
	const [visibleWords, setVisibleWords] = useState(0);

	useEffect(() => {
		if (!shouldAnimate || wordCount === 0) return undefined;
		const timer = setTimeout(() => {
			setVisibleWords(1);
		}, ANIMATION_START_DELAY_MS);
		return () => clearTimeout(timer);
	}, [shouldAnimate, wordCount]);

	useEffect(() => {
		if (!shouldAnimate || visibleWords === 0 || visibleWords >= wordCount) return undefined;
		const timer = setTimeout(() => {
			setVisibleWords((prev) => prev + 1);
		}, ANIMATION_WORD_DELAY_MS);
		return () => clearTimeout(timer);
	}, [shouldAnimate, visibleWords, wordCount]);

	const animationComplete = shouldAnimate && wordCount > 0 && visibleWords >= wordCount;

	return { animationComplete, visibleWords };
}
